import React from "react";
import { Stack } from "expo-router";
import { MobileHeader } from "@/screens/menu/mobile.header";

export default function WalletLayout() {
  return (
    <MobileHeader>
      <Stack.Screen
        name="index"
        options={{ title: "My wallet", headerShown: false }}
      />
    </MobileHeader>
  );
}
